import React from "react";
import Pricing from "../components/Pricing";

function Products() {
  return <Pricing />;
}

export default Products;
